import React, { useState, useEffect, useReducer } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import dayjs from "dayjs";
import StepLabel from "@mui/material/StepLabel";
import SalesForceStep from "./SalesForceStep";
import AccountNumberStep from "./AccountNumberStep";
import { get } from "aws-amplify/api";
import { post } from "aws-amplify/api";
import { I18n } from "aws-amplify/utils";
import currentUserToken from "CurrentUserToken";
import CreateConfirmationDialog from "./CreateConfirmationDialog";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

function StepperDialog(props,) {
  // const {billingCode}=props;
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  
  const [stepOneFormData, setStepOneFormData] = useState({
    name: "",
    billing_country: "",
    billing_city: "",
    billing_postal_code: "",
    account_number: "",
  });
  const [disableBackButton, setDisableBackButton] = useState(false);
  const [selectedAccountNumber, setSelectedAccountNumber] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const steps = [
    I18n.get("Find Account Number"),
    I18n.get("Submit Salesforce Case"),
  ];
  
  const [currentStep, setCurrentStep] = useState(0);
  const [assetNumericError, setAssetNumericError] = useState(null);
  const [formData, setFormData] = useState({
    caseorigin: "Telemonitoring",
    type: "Service Call",
    subtype: "Functional",
    toBeBundled: false,
    subject: "",
    account_number: "",
    account_id: "",
    asset: "",
    salesorganization: "",
    description: "",
    createWorkOrder:false,
    work_order:""
  });

  useEffect(() => {
    if (props.alarm && Array.isArray(props.alarm)) {
      if (props.alarm.length === 0) {
        setCurrentStep(0); // Step 0 when alarm is empty
      } else if (props.alarm.length === 1) {
        // Populate formData for a single alarm
        setCurrentStep(1);
        setDisableBackButton(true)
        setFormData({
          ...formData,
          account_number: props.alarm[0].account_number || "",
          account_id: props.alarm[0].account_id || "",
          //subject: (props.alarm[0].original_equipment + " - " + props.alarm[0].alarm_text) || "",
          asset: props.alarm[0].asset || "",
          description: (props.alarm[0].original_equipment + " - " + props.alarm[0].alarm_text) || "",
        });
      } else {
        // Handle multiple alarms
        const commonAccountNumber = props.alarm[0].account_number;
        const selectID = props.alarm[0].account_id; // Assuming all alarms have the same account_number
        setCurrentStep(1);
        setDisableBackButton(true)
        setFormData({
          caseorigin: "Telemonitoring",
          type: "Service Call",
          subtype: "Functional",
          account_number: commonAccountNumber,
          account_id: selectID, // Keep this empty for multiple alarms
          subject: "", // Keep this empty for multiple alarms
          asset: "", // Keep this empty for multiple alarms
          description: "", // Keep this empty for multiple alarms
          work_order:""
        });
      }
    }
  }, []);

  const fetchAccountNumbers = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/accountNumber/get",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleOpenSalesforceCase = () => {
    props.handleCreateSalesforceCase(formData);
  };

  const handleMainFormData = (field, value) => {
    setFormData((currentState) => ({
      ...currentState,
      [field]: value,
    }));
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };


  return (
    <Dialog
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      maxWidth="xl"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{I18n.get("Submit a Salesforce Case")}</DialogTitle>
      <DialogContent>
        <Stepper activeStep={currentStep}>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {currentStep === 0 && (
          <AccountNumberStep
            fetchData={fetchAccountNumbers}
            handleMainFormData={handleMainFormData}
            stepOneFormData={stepOneFormData}
            state={state}
            selectedAccountNumber={selectedAccountNumber}
            setSelectedAccountNumber={setSelectedAccountNumber}
            mainFormData={formData}
          />
        )}
        {currentStep === 1 && (
          <SalesForceStep
            assetNumericError={assetNumericError}
            setAssetNumericError={setAssetNumericError}
            handleMainFormData={handleMainFormData}
            mainFormData={formData}
            // billingCode={billingCode}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ pt: 2, cursor: 'move' }}>
  {currentStep > 0 && (
    <Button color="primary" disabled={disableBackButton} onClick={handleBack}>
      {I18n.get("Back")}
    </Button>
  )}
  {currentStep === 0 && (
    <>
      <Button
        type="button"
        color="primary"
        onClick={() => props.onClose()}
        style={{ marginLeft: "10px" }}
      >
        {I18n.get("Cancel")}
      </Button>
      <Button
        color="primary"
        onClick={handleNext}
        disabled={!formData.account_number}
      >
        {I18n.get("Next")}
      </Button>
    </>
  )}
  {currentStep === 1 && (
    <>
      <Button
        color="primary"
        onClick={() => props.onClose()}
        style={{ marginLeft: "10px" }}
      >
        {I18n.get("Cancel")}
      </Button>
      <Button
        color="primary"
        onClick={() => setConfirmationOpen(true)}
        disabled={
          !(
            formData.account_number &&
            formData.asset &&
            !assetNumericError &&
            formData.subject &&
            formData.description &&
            formData.salesorganization &&
            (formData.subject.length <= 40)
          )
        }
      >
        {I18n.get("Submit")}
      </Button>
    </>
  )}
</DialogActions>

      <CreateConfirmationDialog
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onSave={handleOpenSalesforceCase}
        onCancel={() => setConfirmationOpen(false)}
      />
    </Dialog>
  );
}

export default StepperDialog;
